import { Hero } from "../components/landing/Hero";
import { Marquee } from "../components/landing/Marquee";
import { Impact } from "../components/landing/Impact";
import { Stories } from "../components/landing/Stories";
import { Areas } from "../components/landing/Areas";
import { Support } from "../components/landing/Support";
import { Covid } from "../components/landing/Covid";
import { Contact } from "../components/landing/Contact";

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <Impact />
      <Stories tone="sand" />
      <Areas />
      <Support />
      <Covid />
      <Contact />
    </>
  );
}
